import { render, staticRenderFns } from "./cancellation_reasons.vue?vue&type=template&id=1641681e&scoped=true"
import script from "./cancellation_reasons.vue?vue&type=script&lang=js"
export * from "./cancellation_reasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641681e",
  null
  
)

export default component.exports